module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ChangeStoreView.js"));
	}, "VirtualPointView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=VirtualPointView!./src/pages/Shop/Member/Personal/ChangeStore/ChangeStoreView.js
// module id = 1474
// module chunks = 418